// One page of the Compliance table in a single request: the people the employee filter
// finds, and their hours and inspections over the other two filters' dates. ServiceInspection's
// ComplianceListExecutor answers with the EmployeeMap, UserMap, RoleMap, TimesheetMap,
// VehicleInspectionMap, VehicleMap and CategoryMap under their usual model names, and the
// people's count under ComplianceOperations.List.CountKey.
export default class ComplianceOperations {

  constructor(eventsDomain) {
    this.eventsDomain = eventsDomain;
    this.domain = this.eventsDomain.domain;
  }

  contains(name) {
    if (name) {
      //
    }
    return false;
  }

  list(employeeFilter, timesheetFilter, inspectionFilter) {
    var event = new ComplianceOperations.List.Operation(employeeFilter, timesheetFilter, inspectionFilter);
    return this.eventsDomain.initRequest(event);
  }

  static List = {
    Names: {
      Operation: 'ComplianceListQueryOperation',
      Notification: 'ComplianceListNotification',
    },

    CountKey: 'count',

    Operation: function (employeeFilter, timesheetFilter, inspectionFilter) {
      var event = {
        handler: ComplianceOperations.List.Names.Operation,
        eventName: ComplianceOperations.List.Names.Operation,
        employeeFilter: employeeFilter.data,
        timesheetFilter: timesheetFilter.data,
        inspectionFilter: inspectionFilter.data,
      }
      return event;
    },
  }
}
